<template>
  <div v-if="data" class="app flex-row align-items-center">
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <table class="mainTable m-3 p-4 h-100 w-100">
      <div style="border: 0px solid">
        <thead style="font-family: iransans">
          <hr />
          <v-row id="header" :class="mt - 1">
            <v-col cols="1">
              <b-img src="/img/brand/small.png" class="w-100" />
            </v-col>
            <v-col style="font-size: 100% !important" cols="3"></v-col>
            <v-col style="font-size: 100% !important" cols="3">
              <b-img src="/img/brand/big.png" class="w-100" />
            </v-col>
            <v-col style="font-size: 100% !important" cols="3"></v-col>
            <v-col class="m-auto" cols="2">
              <v-row>کد ردیابی: {{ data.factoryCode }}</v-row>
              <v-row>تاریخ ابلاغ: {{ data.factoryDate.split("-")[0] }}</v-row>
              <v-row>تاریخ خروجی: {{ myDate }}</v-row>
            </v-col>
          </v-row>
        </thead>

        <tfoot style="font-family: iransans">
          <hr />
          <v-row>
            <v-col class="mx-2">
              <h5>اطلاعات مشتری</h5>
              <v-row>
                <v-col cols="6">
                  <h6>نام مشتری: {{ data.customerName }}</h6>
                  <h6>کد ردیابی: {{ data.factoryCode }}</h6>
                  <h6 v-if="data.originalRequestId">
                    شماره درخواست مشتری:
                    {{ data.originalRequestId }}
                  </h6>
                </v-col>
                <v-col cols="6">
                  <h6 v-if="data.factoryCustomerAgentName">
                    نام نماینده مشتری:
                    {{ data.factoryCustomerAgentName }}
                  </h6>
                  <h6 v-if="data.factoryOtherDescriptions">
                    توضیحات:
                    {{ data.factoryOtherDescriptions }}
                  </h6>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col style="font-size: 100% !important" cols="6"
              >دفتر: تهران، خیابان پاسداران، برج سفید، طبقه 6، واحد 601</v-col
            >
            <v-col style="font-size: 100% !important" cols="3"
              >تلفن: 22542000 - 22547800</v-col
            >
            <v-col style="font-size: 100% !important" cols="3"
              >فاکس: 22553905</v-col
            >
          </v-row>
          <v-row>
            <v-col style="font-size: 100% !important" cols="6"
              >کارخانه: جاده خراسان، بعد از پلیس‌راه شریف‌آباد، شهرک صنعتی عباس
              آباد</v-col
            >
            <v-col style="font-size: 100% !important" cols="3"
              >تلفن: 36423241-2</v-col
            >
            <v-col style="font-size: 100% !important" cols="3"
              >فاکس: 36423680</v-col
            >
          </v-row>
          <hr /> -->
          <hr />
        </tfoot>

        <tbody>
          <v-row class="mt-3"> </v-row>
          <hr />
          <b-table
            v-if="!busy"
            responsive
            show-empty
            head-variant="light"
            :items="data.items"
            :fields="orderFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :style="
              'font-size: ' +
              computedTableValue +
              'px !important;font-family: Tahoma !important'
            "
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  color: #990000;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(notes)="data">
              <div v-html="data.item.notes" v-if="data.item.notes" />
            </template>
            <template v-slot:cell(perPrice)="data">
              <div
                dir="ltr"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ sarmadNumber2(data.item.perPrice * 1) }}
              </div>
            </template>
            <template v-slot:cell(number)="data">
              <div
                dir="rtl"
                :style="
                  'text-align: center; vertical-align: middle; font-size: ' +
                  computedTableValue +
                  'px;'
                "
              >
                {{ parseInt(data.item.number * 1).toLocaleString() }}
                {{ measurementUnit }}
              </div>
            </template>
          </b-table>
        </tbody>
      </div>
    </table>
  </div>
</template>

<script>
import Axios from "axios";
import Vue from "vue";
import Var from "../../variables";
import router from "../router";
import moment from "moment-jalaali";
import prices from "../mixins/prices";

export default {
  mixins: [prices],

  data() {
    return {
      moment: moment,
      currency: "ریال",
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      data: "",
      vat: 9,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      certificationCost: 0,
      otherCost: 0,
      discount: 0,
      extraDetails: false,
      myDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields1: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "index", label: "#" },
      ],
      fields1CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "index", label: "#" },
      ],
      orderFields: [
        { key: "notes", label: "توضیحات" },
        { key: "progress", label: "پیشرفت" },
        { key: "status", label: "وضعیت محصول" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "itemCode", label: "شماره سفارش" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "ردیف" },
      ],
      hasCustomerIndex: false,
      hasSizeStandard: true,
      myFields: [],
      orderItems: [],
      measurementUnit: "",
      printType: "technical",
      busy: true,
      printLinks: "",
      computedMarginValue: 3,
      computedTableValue: 15,
      sizeItems: [
        { value: 7, text: "---" },
        { value: 9, text: "--" },
        { value: 10, text: "-" },
        { value: 11, text: "استاندارد" },
        { value: 12, text: "+" },
        { value: 13, text: "++" },
        { value: 15, text: "+++" },
      ],
    };
  },
  methods: {
    sarmadNumber2(data) {
      let temp1 = parseFloat(data).toFixed(
        this.currencyOptions.filter((x) => x.value == this.currency)[0]
          .precision
      );

      return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
    },

    sarmadNumber(data) {
      let temp1 = parseFloat(
        parseFloat(data).toFixed(
          this.currencyOptions.filter((x) => x.value == this.currency)[0]
            .precision
        )
      );
      return temp1 ? temp1 : 0;
    },
    getData() {
      this.busy = true;
      this.printType = "technical";
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.data = res.data;
            if (res.data.measurementUnit) {
              if (res.data.measurementUnit == "کیلوگرم") {
                if (
                  this.data.productsTemplate == "pk1" ||
                  this.data.productsTemplate == "pk2"
                ) {
                  this.measurementUnit = "کیلوگرم";
                } else {
                  this.measurementUnit = "kg";
                }
              } else if (res.data.measurementUnit == "تن") {
                if (
                  this.data.productsTemplate == "pk1" ||
                  this.data.productsTemplate == "pk2"
                ) {
                  this.measurementUnit = "تن";
                } else {
                  this.measurementUnit = "ton";
                }
              }
            }
            this.orderItems = JSON.parse(this.data.orderItems);

            this.extraDetails = Boolean(
              this.orderItems.map((x) => x.details).reduce((a, b) => a + b)
            );

            this.vat = this.data.orderVat;
            this.packagingCost = this.data.packagingCost;
            this.transportCost = this.data.transportCost;
            this.personCost = this.data.personCost;
            this.coatingCost = this.data.coatingCost;
            this.certificationCost = this.data.certificationCost;
            this.otherCost = this.data.otherCost;
            this.discount = this.data.discount;
            this.hasSizeStandard = this.data.orderHasSizeStandard;
            this.hasCustomerIndex = this.data.hasCustomerIndex;
            this.currency = this.data.currency;

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////
            this.myFields = this.hasCustomerIndex
              ? this.data.productsTemplate == "pk1"
                ? this.fields1CI
                : this.data.productsTemplate == "pk2"
                ? this.fields2CI
                : this.formTemplate == "pken2"
                ? this.fieldsen2CI
                : this.fieldsenCI
              : this.data.productsTemplate == "pk1"
              ? this.fields1
              : this.data.productsTemplate == "pk2"
              ? this.fields2
              : this.formTemplate == "pken2"
              ? this.fieldsen2
              : this.fieldsen;

            if (!this.hasSizeStandard) {
              this.myFields = this.myFields.filter(
                (x) => x.key != "dimensionStandard"
              );
            }

            if (!this.extraDetails) {
              this.myFields = this.myFields.filter((x) => x.key != "details");
            }

            if (this.printType == "technical" || this.printType == "noPrice") {
              this.myFields = this.myFields
                .filter((x) => x.key != "perPrice")
                .filter((x) => x.key != "totalPrice");
            }

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            this.busy = false;

            setTimeout(() => {
              window.print();
            }, 1000);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
p {
  font-family: iransans;
}

td {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style scoped>
p,
div {
  font-size: 11px;
  line-height: 1rem;
}

thead {
  background-color: white;
  color: black;
}

@media print {
  @page {
    margin: 0;
    size: a4 landscape;
    font-size: 30%;
    text-color: black;
  }

  .noPrint {
    display: none !important;
  }

  body {
    margin: 1.6cm;
  }

  table {
    border: 1px solid;
  }

  table.mainTable {
    border: 0px !important;
  }

  /* tfoot:after {
    counter-increment: page;
    content: "صفحه " counter(page);
  } */
}
</style>
